export const userTypeCookieName = 'spruce_user_type';
